import { useEffect, useState } from 'react';
function getInitialType(duration, durationOptions) {
  const maxDuration = duration.max;
  const minDuration = duration.min;
  const isInput = maxDuration !== minDuration;
  const isChipValue = durationOptions.options.some(chipValue => chipValue.min === minDuration);
  const shouldUseChip = !isInput && isChipValue;
  return shouldUseChip ? 'chip' : 'input';
}
export function useInputTypeState(duration, durationOptions, rawDuration) {
  const [inputType, setInputType] = useState(() => getInitialType(duration, durationOptions));
  const [isDirty, setIsDirty] = useState(false);
  useEffect(() => {
    // update input type when:
    // - duration change to null
    // - duration is changed, but not user yet (not dirty)
    if (rawDuration === null || !isDirty) {
      setInputType(getInitialType(duration, durationOptions));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to run this effect when rawDuration changes
  }, [rawDuration]);
  return [inputType, newValue => {
    setIsDirty(true);
    setInputType(newValue);
  }];
}